import { FC } from "react";
import { useFragment } from "react-relay";
import { Link, useNavigate } from "react-router-dom";
import { graphql } from "relay-runtime";
import { Button, Decimal, i18n, IconDenom } from "rujira.ui";
import { GhostVaultThumbFragment$key } from "./__generated__/GhostVaultThumbFragment.graphql";

const fragment = graphql`
  fragment GhostVaultThumbFragment on GhostVaultAccount {
    id
    account
    vault {
      asset {
        asset
        metadata {
          symbol
        }
      }
    }
    valueUsd
    receiptValue: value {
      amount
      asset {
        price {
          current
        }
        metadata {
          symbol
        }
      }
    }
  }
`;

export const GhostVaultThumb: FC<{ k: GhostVaultThumbFragment$key }> = ({
  k,
}) => {
  const data = useFragment(fragment, k);
  const url = `/strategies/lend/${data.vault.asset.asset}`;

  return (
    <div className="relative card p-3">
      <div className="flex ai-c mt-0.5">
        <div className="lp">
          <IconDenom denom={data.vault.asset.metadata.symbol || ""} />
        </div>
        <h3 className="condensed fs-24 fw-400 mb-0 ml-1">
          {data.vault.asset.metadata.symbol || ""}{" "}
        </h3>
        <i18n.div className="tag tag--teal ml-a mr-0">Lending</i18n.div>
      </div>
      <div className="row wrap pad--mini mt-2">
        <div className="col-4">
          <i18n.h4 className="fs-16 lh-22 fw-400 color-grey mb-0">
            Value
          </i18n.h4>

          <Decimal
            symbol="$"
            symbolLeft
            amount={BigInt(data.valueUsd)}
            round={2}
            className="fs-24 condensed"
          />
        </div>
      </div>
      <Button
        as={Link}
        to={url}
        className="button--small button--outline mt-2 w-full"
        label="Manage Position"
      />
    </div>
  );
};

export const GhostVaultRow: FC<{ k: GhostVaultThumbFragment$key }> = ({
  k,
}) => {
  const data = useFragment(fragment, k);
  const url = `/strategies/lend/${data.vault.asset.asset}`;
  const navigate = useNavigate();

  return (
    <tr onClick={() => navigate(url)} className="pointer">
      <td className="flex ai-c mt-0.5 pointer">
        <IconDenom
          denom={data.vault.asset.metadata.symbol || ""}
          className="w-3.5 mx-0.5"
        />
      </td>
      <td style={{ paddingLeft: "0" }}>
        {data.vault.asset.metadata.symbol || ""}{" "}
      </td>
      <td>
        <i18n.div className="tag tag--teal ml-a mr-0">Lending</i18n.div>
      </td>
      <td>
        <Decimal
          key={data.receiptValue.asset.metadata.symbol}
          symbol={data.receiptValue.asset.metadata.symbol}
          amount={BigInt(data.receiptValue.amount)}
          round={4}
          symbolClassName="decimal__symbol--small color-grey condensed fw-500 mr-1"
        />
      </td>
      <td className="text-right">Soon&trade;</td>
      <td className="text-right">
        <Decimal
          symbol="$"
          symbolLeft
          amount={BigInt(data.valueUsd)}
          decimals={8}
          round={2}
        />
      </td>
    </tr>
  );
};
